module.exports = __webpack_public_path__ + "img/erp_system.bfc1d6f0.jpg";